let gql = null;
try {
  gql = require('@apollo/client').gql;
} catch (er) {}
export const MYKBB_MENU_ID = 'mykbbToggle';
export const GLOBALNAV_KBB_STAGING_URL = 'https://staging.kbb.com';
export const GLOBALNAV_KBB_BASE_URL = process.env.NODE_ENV === 'production' ? '' : GLOBALNAV_KBB_STAGING_URL;
export const isMobile = typeof window === 'object' ? 'ontouchstart' in window : false;